import { createContext } from 'react';
import { QUERY_KEYS_OBJECTS, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const DetailsChartsDataContext = createContext();

const DetailsChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(parseInt(filters.month.value)) : '',
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_DETAILS_RUBRIC,
            url: 'governanceroom/securitydashboard/objects/details/rubric'
        },
        filterParams
    );

    const conductEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_DETAILS_CONDUCT,
            url: 'governanceroom/securitydashboard/objects/details/conduct'
        },
        filterParams
    );

    const presentationEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_DETAILS_PRESENTATION,
            url: 'governanceroom/securitydashboard/objects/details/presentation'
        },
        filterParams
    );

    const authorshipEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_DETAILS_AUTORSHIP,
            url: 'governanceroom/securitydashboard/objects/details/authorship'
        },
        filterParams
    );

    const flagrantEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_DETAILS_FLAGRANT,
            url: 'governanceroom/securitydashboard/objects/details/flagrant'
        },
        filterParams
    );


    const infractionalEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_DETAILS_INFRACTIONAL,
            url: 'governanceroom/securitydashboard/objects/details/infractional'
        },
        filterParams
    );

    const unfoldingEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_DETAILS_UNFOLDING,
            url: 'governanceroom/securitydashboard/objects/details/unfolding'
        },
        filterParams
    );

    const circumstanceEvolutionData = useChartsData(
        {
            key: QUERY_KEYS_OBJECTS.OBJECTS_DETAILS_CIRCUMSTANCES,
            url: 'governanceroom/securitydashboard/objects/details/circumstance'
        },
        filterParams
    );


    const chartData = {
        rubricEvolutionAnual: data?.anualEvolution || [],
        rubricEvolutionMonth: data?.monthEvolution || [],
        conductEvolutionAnual: conductEvolutionData.data?.anualEvolution || [],
        conductEvolutionMonth: conductEvolutionData.data?.monthEvolution || [],
        presentationEvolutionAnual: presentationEvolutionData.data?.anualEvolution || [],
        presentationEvolutionMonth: presentationEvolutionData.data?.monthEvolution || [],
        authorshipEvolutionAnual: authorshipEvolutionData.data?.anualEvolution || [],
        authorshipEvolutionMonth: authorshipEvolutionData.data?.monthEvolution || [],
        flagrantEvolutionAnual: flagrantEvolutionData.data?.anualEvolution || [],
        flagrantEvolutionMonth: flagrantEvolutionData.data?.monthEvolution || [],
        infractionalEvolutionAnual: infractionalEvolutionData.data?.anualEvolution || [],
        infractionalEvolutionMonth: infractionalEvolutionData.data?.monthEvolution || [],
        unfoldingEvolutionAnual: unfoldingEvolutionData.data?.anualEvolution || [],
        unfoldingEvolutionMonth: unfoldingEvolutionData.data?.monthEvolution || [],
        circumstanceEvolutionAnual: circumstanceEvolutionData.data?.anualEvolution || [],
        circumstanceEvolutionMonth: circumstanceEvolutionData.data?.monthEvolution || []
    }

    return (
        <DetailsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </DetailsChartsDataContext.Provider>
    );
};

export default DetailsChartsDataProvider;
